export enum LocalRoutes {
   BLOG_LIST = "/blog",
   BLOG_EDIT = "/blog/edit",
   AGENCY_LIST = "/agency",
   PARTNER_LIST = "/partner/partners",
   PARTNER_CREATE = "/partner/campaign/create",
   COMPANY_EDIT = "/company/edit",
   VERIFICATION = 'verification-page'
}
